const KNOWN_SECTION_TYPES = new Set(["navBar"]);
const KNOWN_WIDGET_TYPES = new Set(["navItem"]);

const requiredString = (value) => typeof value === "string" && value.trim().length > 0;

function validateNavItem(widget, pathPrefix, errors) {
  if (!requiredString(widget?.id)) {
    errors.push(`${pathPrefix}.id is required`);
  }

  if (widget?.type !== "navItem") {
    errors.push(`${pathPrefix} must have type "navItem"`);
  }

  if (!requiredString(widget?.labelKey)) {
    errors.push(`${pathPrefix}.labelKey is required`);
  }

  if (!requiredString(widget?.path) && !requiredString(widget?.actionKey)) {
    errors.push(`${pathPrefix} must have path or actionKey`);
  }

  if (Array.isArray(widget?.children)) {
    widget.children.forEach((child, childIndex) => {
      validateNavItem(child, `${pathPrefix}.children[${childIndex}]`, errors);
    });
  }
}

export function validateNavLayout(layout) {
  const errors = [];

  if (!layout || typeof layout !== "object") {
    return { valid: false, errors: ["Layout must be an object"] };
  }

  if (typeof layout.schemaVersion !== "number") {
    errors.push("schemaVersion must be a number");
  }

  if (!requiredString(layout.pageId)) {
    errors.push("pageId is required");
  }

  if (!Array.isArray(layout.sections) || layout.sections.length === 0) {
    errors.push("sections must be a non-empty array");
  } else {
    const hasNavBar = layout.sections.some((section) => section?.type === "navBar");
    if (!hasNavBar) {
      errors.push("sections must include a navBar section");
    }

    layout.sections.forEach((section, sectionIndex) => {
      if (!requiredString(section?.id)) {
        errors.push(`sections[${sectionIndex}].id is required`);
      }

      if (!requiredString(section?.type)) {
        errors.push(`sections[${sectionIndex}].type is required`);
      } else if (!KNOWN_SECTION_TYPES.has(section.type)) {
        errors.push(`sections[${sectionIndex}] has unknown type "${section.type}"`);
      }

      if (section?.type === "navBar") {
        if (!Array.isArray(section.widgets) || section.widgets.length === 0) {
          errors.push(`sections[${sectionIndex}].widgets must be a non-empty array`);
        } else {
          section.widgets.forEach((widget, widgetIndex) => {
            if (!KNOWN_WIDGET_TYPES.has(widget?.type)) {
              errors.push(
                `sections[${sectionIndex}].widgets[${widgetIndex}] has unknown type "${widget?.type}"`,
              );
            }
            validateNavItem(
              widget,
              `sections[${sectionIndex}].widgets[${widgetIndex}]`,
              errors,
            );
          });
        }
      }
    });
  }

  return { valid: errors.length === 0, errors };
}
